import React, { useContext, useState } from "react";
import MenuTool from "../../components/Toolnav/MenuTool";
import Course from "./components/Course";
import { AiOutlinePlus } from "react-icons/ai";
import AddCourse from "./components/AddCourse";
import { handleFetchCourses } from "../../api/course";
import { useQuery } from "@tanstack/react-query";
import { AuthContext } from "../../contexts/AuthContext";

export default function AllCourses() {
  const { auth } = useContext(AuthContext);
  const access = ["Admin", "Instructor"];
  const [createModal, setCreateModal] = useState<boolean>(false);

  const { data: courses } = useQuery({
    queryKey: ["courses"],
    queryFn: handleFetchCourses,
  });

  return (
    <div className="">
      <MenuTool
        menus={[{ id: 1, name: "All Courses", to: "/courses" }]}
        actions={
          <>
            {access?.includes(auth?.role) && (
              <button
                onClick={() => setCreateModal(true)}
                className="flex justify-center items-center border py-1 px-4 bg-blue-100"
              >
                <AiOutlinePlus /> <span className="mx-1">Add</span>
              </button>
            )}
          </>
        }
      />
      <div className="p-2">
        <div className="grid grid-cols-12 gap-2">
          {courses?.payload?.map((course: any, index: number) => (
            <Course course={course} key={index} />
          ))}
        </div>
      </div>

      <AddCourse isVisible={createModal} setVisible={setCreateModal} />
    </div>
  );
}
